import { render } from "./how_to_order.vue?vue&type=template&id=1889b96e"
import script from "./how_to_order.vue?vue&type=script&lang=js"
export * from "./how_to_order.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__